import { computed } from "vue";
function useHeightProps() {
  function createHeightProps(heightValues = {}) {
    const { height = "auto", minHeight = "auto", maxHeight = "auto" } = heightValues;
    return {
      height: {
        type: String,
        default: height
      },
      minHeight: {
        type: String,
        default: minHeight
      },
      maxHeight: {
        type: String,
        default: maxHeight
      }
    };
  }
  function getHeightStyles(props) {
    const heightStyles = computed(() => ({
      height: props.height,
      minHeight: props.minHeight,
      maxHeight: props.maxHeight
    }));
    return {
      heightStyles
    };
  }
  return {
    createHeightProps,
    getHeightStyles
  };
}
export {
  useHeightProps as u
};
